import { render, staticRenderFns } from "./kra-outcome-tax.vue?vue&type=template&id=67ddcbb8&scoped=true&"
import script from "./kra-outcome-tax.vue?vue&type=script&lang=js&"
export * from "./kra-outcome-tax.vue?vue&type=script&lang=js&"
import style0 from "./kra-outcome-tax.vue?vue&type=style&index=0&id=67ddcbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddcbb8",
  null
  
)

export default component.exports